import React, { useState, useEffect } from 'react'
import './UserLegacyCredits.css'
import PageTitle from '../components/UI/PageTitle'
import Separator from '../components/UI/Separator'
import { getLegacyCreditsByUser } from '../api/Index'
import { useAuth } from '../api/Authcontext'

const UserLegacyCredits = () => {
    const { userData, getUserId } = useAuth();
    const [legacyCredits, setLegacyCredits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserLegacyCredits = async () => {
            console.log('UserLegacyCredits component mounted');
            setLoading(true);
            setError(null);
            try {
                const userId = getUserId();
                console.log('Current user ID:', userId);
                
                if (!userId) {
                    setError('User not authenticated');
                    return;
                }

                console.log('Calling getLegacyCreditsByUser with ID:', userId);
                const response = await getLegacyCreditsByUser(userId);
                console.log('Legacy credits response:', response);
                
                // Handle response - backend returns array directly
                const creditsData = response.data || [];
                console.log('Parsed legacy credits data:', creditsData);
                setLegacyCredits(creditsData);
                
            } catch (err) {
                console.error('Error fetching legacy credits:', err);
                console.error('Error response:', err.response);
                console.error('Error message:', err.message);
                setError(err.response?.data?.msg || err.message || 'Failed to load legacy credits');
            } finally {
                console.log('Finished loading legacy credits data');
                setLoading(false);
            }
        };

        fetchUserLegacyCredits();
    }, [getUserId]);

    const LegacyCreditCard = ({legacyCredit}) => {
      // Format date from backend data
      const formatDate = (dateString) => {
        if (!dateString) return 'Not available';
        return new Date(dateString).toLocaleDateString();
      };

      // Format month from backend date
      const formatMonth = (dateString) => {
        if (!dateString) return 'Unknown';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      };

      return (
        <div>

          <div className='space-between'>
            <h4>{formatMonth(legacyCredit.month)}</h4>
            <p className='legacy-status'>{legacyCredit.status || 'pending'}</p>
          </div>

          <div className='legacy-details'>
            <div className='space-between'>
              <p>Paid Amount:</p>
              <p>KES: {legacyCredit.price || (legacyCredit.amount * 1000) || 1000}</p>
            </div>
            <div className='space-between'>
              <p>Equivalent Legacy Credits:</p>
              <p>{legacyCredit.amount || legacyCredit.legacyCredits || 1}</p>
            </div>
            <div className='space-between'>
              <p>Payment Method:</p>
              <p>{legacyCredit.paymentMethod || 'N/A'}</p>
            </div>
            <div className='space-between'>
              <p>Receipt:</p>
              <p>{legacyCredit.receiptNumber || legacyCredit.receipt || 'N/A'}</p>
            </div>
            <div className='space-between'>
              <p>Paid On:</p>
              <p>{formatDate(legacyCredit.paidOn || legacyCredit.createdAt)}</p>
            </div>
          </div>

        </div>
      )
    }


  if (loading) {
    return (
      <div>
        <PageTitle title='My Legacy Credits' />
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>Loading your legacy credits...</p>
          <p style={{ color: '#666', fontSize: '14px' }}>Please wait while we fetch your data.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageTitle title='My Legacy Credits' />
        <div style={{ padding: '20px', backgroundColor: '#ffe6e6', border: '1px solid #ff0000', borderRadius: '4px', margin: '20px' }}>
          <h3 style={{ color: 'red', margin: '0 0 10px 0' }}>Error Loading Legacy Credits</h3>
          <p style={{ color: 'red', margin: '0' }}>{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            style={{ marginTop: '10px', padding: '8px 16px', backgroundColor: '#ff0000', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageTitle title='My Legacy Credits' />
      {legacyCredits.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>No legacy credits found.</p>
          <p style={{ color: '#666', fontSize: '14px' }}>You haven't made any legacy credit payments yet.</p>
        </div>
      ) : (
        <>
          <div>
            {legacyCredits.map((legacyCredit, index) => (
              <>
                <LegacyCreditCard key={legacyCredit._id || index} legacyCredit={legacyCredit} />
                <Separator />
              </>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default UserLegacyCredits